'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "divider", "headingText"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import NavList from './NavList';
import HR from 'UIComponents/elements/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class NestedNav extends Component {
  render() {
    const _this$props = this.props,
      {
        children,
        className,
        divider,
        headingText
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsxs(NavList, Object.assign({}, rest, {
      className: className,
      _rootComponent: NestedNav,
      children: [divider ? /*#__PURE__*/_jsx(HR, {}) : null, headingText ? /*#__PURE__*/_jsx("span", {
        className: "is--heading-7",
        children: headingText
      }) : null, children]
    }));
  }
}
NestedNav.displayName = 'NestedNav';
NestedNav.propTypes = Object.assign({}, NavList.propTypes, {
  divider: PropTypes.bool,
  headingText: PropTypes.node
});
NestedNav.defaultProps = Object.assign({}, NavList.defaultProps, {
  divider: false,
  headingText: ''
});
export default NestedNav;